import { IContractCancelReason } from './contract.model';
import { ICardSetting } from './contract.model';

export interface IAccount {
  code: string;
  id: number;
  country: string;
  created_at: Date;
  updated_at: Date | null;
  deleted_at: null;
  status: string;
  blocking_reason_code: string | null;
  blocking_reason_description: string | null;
  blocking_type: string | null;
  blocked_type: [] | [];
  number_folio: null;
  product_catalog_id: string;
  main_account: boolean;
  closed_by: null;
  description: string;
  external_number: string;
}

export interface IAccountDetail {
  id: number;
  code: string;
  country: string;
  number: string;
  external_number: string;
  type: string;
  subtype: string;
  origin: string;
  status: string;
  currency: string;
  user_code: string;
  delete_at: any;
  is_gmf: boolean;
  date_breaklimit: any;
  business_type: string;
  level: string;
  product_catalog_id: string;
  main_account: boolean;
  tax: ITaxDetailAccount;
  description: string;
  description_legal: string;
  account_open: any;
  process: string;
  blocked_type?: [] | [];
}

interface ITaxDetailAccount {
  values: IValueTaxDetail[];
}

interface IValueTaxDetail {
  tax: string;
  apply: boolean;
  gmf_reason: string;
}

export interface IAccountGmf {
  accumulated_limit: string;
  accumulated_free: string;
  accumulated_available: string;
}
export interface IAccountAccumulated {
  accumulated?: IAccountLimits;
  limits?: IAccountLimits;
}
export interface IAccountLimits {
  credit?: IAccountLimit;
  debit?: IAccountLimit;
  balance?: IAccountLimit;
  level?: string;
  gmf?: IAccountLimit;
}

export interface IAccountLimit {
  accumulated?: number;
  percent?: number;
  limit: number;
  title?: string;
  free?: number;
  available?: number;
  monthly?: number;
}

export interface IAccountMovement {
  title: string;
  amount: number;
  description: null;
  image: string;
  icon: string;
  tag: IAccountMovementTag;
  action: string;
  action_detail: null;
  date: string;
  transaction_id: string;
  origin_transaction: string;
  transaction_type: string;
  sub_type: string;
  p2p_users_info: null;
  status: string;
  model_id: null;
  id: number;
}
interface IAccountMovementTag {
  name: string;
  text_color: string;
  background_color: string;
  icon: null;
}

export interface ISideNavAction {
  component: string;
  data?: any;
}

export interface IAccountMovementDetail {
  image?: string;
  title?: string;
  date?: string;
  tag_v2?: ITagV2;
  buttons?: any[];
  support_info?: ISupportInfoMovement;
  info?: IInfoDetailMovement[];
  data?: any;
}

interface IInfoDetailMovement {
  title: ITitle;
  subtitle: ITitle;
  cell: any;
  description: any;
}

interface ITitle {
  text: string;
  font_size: string;
  font_weight: string;
  text_color: string;
}

interface ISupportInfoMovement {
  type: string;
  sub_type: string;
  origin: string;
  amount: number;
  transaction_id: string;
}

interface ITagV2 {
  name: string;
  text_color: string;
  background_color: string;
  icon: any;
  information_dto: any;
}

export interface IAccountBalance {
  total_balance: number;
  available_balance: number;
}

export interface IAccountBalanceTransfered {
  account_id: number;
  account_open: boolean;
  balance_transfer: boolean;
}
// export interface IInitDataStateBanking {
//   rppUserId: string;
//   accountCode: string;
// }

export interface IExonerationGMF {
  action: string;
  agentEmail: string;
  keyId: string;
  entityId: string;
  status: string;
  payload: IPayload;
  reason: string;
  rppUserId: string;
  createdAt: string;
  updatedAt: string;
  loading?: boolean;
  closeModal?: boolean;
}
export interface IPayload {
  id: string;
  user_code: string;
  is_gmf: boolean;
  country: string;
  created_at: string;
  updated_at: string;
  status: string;
  message: string;
}

export interface IAccountBlockingReason {
  id: number;
  value: string;
  index: number;
}

export interface IAccountBlockingReasonRole {
  areaId: string;
  reasons: IBlockingReasonRole[];
}

export interface IBlockingReasonRole {
  block_reason_id: string;
  name: string;
  types: string[];
  areaId: string;
}

export interface IAccountBlockingType {
  id: number;
  reason: number;
  value: string;
  index: number;
}

export interface ICertificateRequest {
  showBalance: boolean;
  toRole?: string;
  toName: string;
  email: string;
}

export interface ICertificateDownloadRequest {
  document_type: string;
  document_date: string;
  external_id: string;
  document_id: string;
}

export interface ICertificateDownloadResponse {
  file: string;
  name: string;
}

export interface ICertificateYearsResponse {
  years: number[];
}

export interface ICancelAccountRequest {
  reason: string;
  email_support: string;
  description?: string;
}
export interface ICancelAccountTransaction {
  transaction: {
    code: string;
    status: string;
    time: number;
    retry: number;
  };
}

export interface IAccountStatementResponse {
  file: string;
  name: string;
}

export interface IAccountStatementRequest {
  from: string;
  to: string;
  period: string;
}

export interface IBlockContractRequest {
  code: string;
  description: string;
}

export interface IBlockUnblockContract {
  contract_code: string;
  reason: IContractCancelReason;
  rpp_user_id: string;
  email_support: string;
  type: string;
}

export interface IReplaceCardContract {
  card_code: string;
  reason: IContractCancelReason;
  rpp_user_id: string;
  agent_email: string;
}

export interface IBaseContract {
  contract_code: string;
  reason: IContractCancelReason;
  rpp_user_id: string;
}

export interface IBlockUnlockTransaction {
  transaction_code: string;
}

export interface IFreezeUnfreezeCardRequest {
  state: string;
  reason: string;
  email_support: string;
  sub_state: string;
  notify_external: string;
}

export interface ICardFeaturesUpdate {
  rppUserId: string;
  contractCode: string;
  features: any;
}

export interface IApplyGmf {
  action: string;
  agentEmail: string;
  keyId: string;
  entityId: string;
  status: string;
  payload: IPayloadGmf;
  reason: string;
  rppUserId: string;
  country: string;
  createdAt: string;
  updatedAt: string;
}
export interface IPayloadGmf {
  id: string;
  user_code: string;
  is_gmf: boolean;
  country: string;
  created_at: string;
  updated_at: string;
  status: string;
  message: string;
}

export interface IBlockAccountParams {
  rppUserId: string;
  accountCode: string;
  reasonId: string;
  reasonDescription?: string;
  typeId: string;
  blockType: string;
  agent_email: string;
  areaId?: string;
  action?: string;
}

export interface IGmfParams {
  rppUserId: string;
  accountCode: string;
  isGmf: boolean;
  agent_email: string;
}

// Extended interface for Persona Jurídica GMF exoneration
export interface IGmfPJParams extends IGmfParams {
  gmfReason: string; // 'TIPO1' | 'TIPO2' | 'TIPO3'
}

export interface ICancelAccountParams {
  rppUserId: string;
  accountCode: string;
  action: string;
  reasonId: string;
  userId: string;
  agent_email?: string;
}

export interface IBlockingReasonsResponse {
  user_code: string;
  account_code: string;
  blocks: IBlocksDTO[];
}

export interface IBlocksDTO {
  reason: string;
  block_at: string;
  types: string[];
}

export interface IAccountFreeze {
  id: string;
  freeze_configuration_id: string;
  freeze_amount: number;
  freeze_balance: number;
  status: string;
  name: string;
  account_code: string;
  created_at: string;
  updated_at: string;
}

export interface IAccountBrebLimit {
  bre_b_limit_amount: number;
}

export interface IBreBKey {
  id: string;
  type: string;
  value: string;
  state: string;
  sub_state?: string;
  is_registered: boolean;
  is_disabled: boolean;
  additional_data?: Record<string, any>;
  qr_codes?: any;
  lock_start_date?: string;
  lock_end_date?: string;
  lock_days?: string;
  extension_applied: boolean;
}

export interface IBreBKeysResponse {
  keys: IBreBKey[];
}
